/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_TitleInputs */

const en_us2_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete your account?`)
};

const pt_br2_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir sua conta?`)
};

const es_419_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar tu cuenta?`)
};

const pt_pt2_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar a tua conta?`)
};

const fr_fr2_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer ton compte ?`)
};

const de_de2_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto löschen?`)
};

const it_it2_profile_editors_delete_title = /** @type {(inputs: Profile_Editors_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare il tuo account?`)
};

/**
* | output |
* | --- |
* | "Delete your account?" |
*
* @param {Profile_Editors_Delete_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_title = /** @type {((inputs?: Profile_Editors_Delete_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_title(inputs)
	return en_us2_profile_editors_delete_title(inputs)
});
export { profile_editors_delete_title as "profile-editors.delete_title" }